import React from "react";

export default function CardMeta({
    meta,
    alcancado
}) {

    const porcentagem = Math.min((alcancado / meta) * 100, 100);

    return (

        <div className="card shadow-sm p-3 mb-4">

            <h5 className="mb-3">
                <i className="fa fa-bullseye me-2"></i>
                Minha Meta
            </h5>

            <p>
                Meta: <strong>{meta}</strong>
                {" | "}
                Alcançado: <strong>{alcancado}</strong>
            </p>

            <div
                className="progress"
                style={{ height: "20px" }}
            >

                <div
                    className="progress-bar bg-success"
                    style={{
                        width: `${porcentagem}%`
                    }}
                >
                    {porcentagem.toFixed(0)}%
                </div>

            </div>

        </div>

    );

}